import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import DashboardCard from './DashboardCard';
import {
  Table, Thead, Tr, Td, ScrollBox,
} from '../styles';
import { formatPercent, formatNumber } from '../constants';

// Kart 5/7 — Kaynak dönüşümü: kaynak başına başvuru/işe alım + dönüşüm oranı.
// Brief "tablo ya da bar" diyor — tablo seçildi (7 sütun karşılaştırması bar
// grafikten daha okunur, ayrıca ek bir chart konfigürasyonuna gerek kalmıyor).
export default function SourceConversionCard({ data, loading }) {
  const { t, i18n } = useTranslation();

  const rows = useMemo(() => (
    [...(data || [])].sort((a, b) => (b.applications ?? 0) - (a.applications ?? 0))
  ), [data]);

  return (
    <DashboardCard
      cardKey="kaynak-donusumu"
      title={t('atsDashboard.sources.title')}
      meta={t('atsDashboard.sources.meta')}
      span={6}
      spanMd={6}
      loading={loading}
      empty={rows.length === 0}
      domId="ats-dash-sources"
    >
      <ScrollBox>
        <Table>
          <Thead>
            <tr>
              <th>{t('atsDashboard.sources.columnSource')}</th>
              <th>{t('atsDashboard.sources.columnApplications')}</th>
              <th>{t('atsDashboard.sources.columnHired')}</th>
              <th>{t('atsDashboard.sources.columnConversionRate')}</th>
            </tr>
          </Thead>
          <tbody>
            {rows.map((row) => (
              <Tr key={row.source}>
                <Td>{row.source}</Td>
                <Td>{formatNumber(row.applications, i18n.language)}</Td>
                <Td>{formatNumber(row.hired, i18n.language)}</Td>
                <Td>{formatPercent(row.conversionRate, i18n.language)}</Td>
              </Tr>
            ))}
          </tbody>
        </Table>
      </ScrollBox>
    </DashboardCard>
  );
}
